export enum SubscriptionIntervalEnum {
  Monthly = 'monthly',
  Annually = 'annually',
  OneTime = 'one_time',
}
